import type { FC } from 'react';

import { type IBaseButtonProps } from './BaseButton'
import { DangerButtonStyled } from './styles/DangerButtonStyled'

export const DangerButton: FC<IBaseButtonProps> = DangerButtonStyled

DangerButton.displayName = 'DangerButton'
